module.exports = __webpack_public_path__ + "img/brand (15).fc7b084a.svg";